// Custom components
import React from "react";

function InputField(props) {
  const { 
    label, 
    id, 
    extra, 
    type, 
    placeholder, 
    variant, 
    state, 
    disabled,
    value,
    onChange,
    error,
    required,
    name
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className={`mt-2 block w-full rounded-md border px-3 py-2 text-sm shadow-sm outline-none relative z-10 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : error
            ? "border-red-300 text-red-500 placeholder:text-red-500 focus:ring-red-500 focus:border-red-500"
            : state === "success"
            ? "border-green-300 text-green-500 placeholder:text-green-500 focus:ring-green-500 focus:border-green-500"
            : "border-gray-300 text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
        }`}
      />
      {error && (
        <span className="mt-1 ml-1.5 text-xs text-red-500">
          {error}
        </span>
      )}
    </div>
  );
}

export default InputField;
